module.exports = __webpack_public_path__ + "static/media/RATLAM_page-0001.bede71a7.jpg";